import { Box, Container } from '@mui/material'
import React, { FC, useContext } from 'react'
import { FormProvider } from 'react-hook-form'
import { z } from 'zod'
import { CreateCampaignHeader } from '~/features/campaign_create/Header'
import { CreateCampaignContext } from '~/contexts/CreateCampaignContext'
import { StoreTemplateList } from '../StoreTemplateList'
import { NavigationButtons } from '../NavigationButtons'
import { StoreInfo as StoreInfoComponent, storeInfoSchema } from '~/features/campaign_input/StoreInfo'
import { useCampaignPageStepForm } from '../useCampaignPageStepForm'
import { CampaignCategory } from '~/generated/graphql'

export const StoreInfo: FC = () => {
  const { campaign } = useContext(CreateCampaignContext)
  const { onSubmit, useFormMethods, onBack } = useCampaignPageStepForm<
    z.input<typeof storeInfoSchema>,
    z.output<typeof storeInfoSchema>
  >({
    defaultValues: {
      cityName: campaign.cityName,
      streetAddress: campaign.streetAddress,
      buildingName: campaign.buildingName,
      shopName: campaign.shopName,
      nearestStationName: campaign.nearestStationName,
      shopPostalCode: campaign.shopPostalCode,
      shopPref: campaign.shopPref ?? '',
      shopTel: campaign.shopTel,
      shopTemplateId: campaign.shopTemplateId,
      category: campaign.category ?? CampaignCategory.Service,
    },
    schema: storeInfoSchema,
  })
  return (
    <form onSubmit={onSubmit}>
      <FormProvider {...useFormMethods}>
        <CreateCampaignHeader title="店舗に関する情報について教えてください" onBack={onBack} />
        <Container maxWidth="md">
          <StoreTemplateList />
          <StoreInfoComponent />
          <Box my={7}>
            <NavigationButtons />
          </Box>
        </Container>
      </FormProvider>
    </form>
  )
}
export default StoreInfo
